import dJSON from 'dirty-json';

/**
 * Card Slide Data
 */
document.querySelectorAll('.js-card-slider').forEach((item) => {
  const cardData = item.data;
  let arr = '';
  const data = dJSON.parse(cardData);

  Object.keys(data).forEach((key) => {
    const entry = data[key];
    const img = entry.image || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-tabs-bg.jpg';
    const logo = entry.logo || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-head-logo.png';
    const name = entry.name || 'Anonymous';
    const title = entry.title || 'Anonymous';
    const textbold = entry.textbold || 'Information coming soon!';
    const text = entry.text || 'Check back later for more info about this testimonial.';

    let logoString = '';
    let textboldString = '';
    let textString = '';

    if (logo) {
      logoString = `<img class="cs-slide-logo" src="${logo}" alt=""></img>`;
    }
    if (textbold) {
      textboldString = `<p><strong>${textbold}</strong></p>`;
    }
    if (text) {
      textString = `<p>${text}</p>`;
    }

    const htmlString = /* html */ `
    <div class="cs-slide">
      <img class="cs-slide-bg" src="${img}" alt="">
      <div class="cs-slide-text">
        ${logoString}
        ${textboldString}
        ${textString}
        <p class="cs-slide-byline"><span class="cs-slide-name text-orange">${name}</span> <span class="cs-slide-title">${title}</span></p>
      </div>
    </div>
    `;

    arr += htmlString;
  });

  item.querySelector('.slide-wrapper').innerHTML = arr;
  item.querySelector('script').remove();
});

/**
 * Card Slider init
 */
(() => {
  document.querySelectorAll('.js-card-slider').forEach((item) => {
    const wrapper = item.querySelector('.slide-wrapper');

    // if less than 5 slides, duplicate all. 5 Are needed for smooth transitions
    const slideCount = item.querySelectorAll('.cs-slide').length;

    switch (slideCount) {
    case 1:
      for (let index = 0; index < 3; index += 1) {
        item.querySelectorAll('.cs-slide').forEach((slide) => {
          wrapper.append(slide.cloneNode(true));
        });
      }
      break;
    case 2:
      for (let index = 0; index < 2; index += 1) {
        item.querySelectorAll('.cs-slide').forEach((slide) => {
          wrapper.append(slide.cloneNode(true));
        });
      }
      break;
    case 3:
    case 4:
      item.querySelectorAll('.cs-slide').forEach((slide) => {
        wrapper.append(slide.cloneNode(true));
      });
      break;
    default:
      break;
    }

    wrapper.prepend(wrapper.querySelector('.cs-slide:last-child'));
    wrapper.querySelector('.cs-slide:nth-child(2)').classList.add('nActive');

    item.querySelectorAll('.nav-arrow').forEach((navArrow) => {
      const slideTransition = (e) => {
        const arrow = e.currentTarget;
        const active = wrapper.querySelector('.nActive');
        if (arrow.classList.contains('nav-next')) {
          if (wrapper.classList.contains('backwards')) {
            wrapper.classList.remove('backwards');
          }
          setTimeout(() => {
            active.classList.remove('nActive');
            active.nextElementSibling.classList.add('nActive');
            wrapper.append(wrapper.querySelector('.cs-slide:first-child'));
          }, 10);
        } else if (arrow.classList.contains('nav-prev')) {
          if (!wrapper.classList.contains('backwards')) {
            wrapper.classList.add('backwards');
          }
          setTimeout(() => {
            active.classList.remove('nActive');
            active.previousElementSibling.classList.add('nActive');
            wrapper.prepend(wrapper.querySelector('.cs-slide:last-child'));
          }, 10);
        }
      };
      navArrow.addEventListener('click', (e) => {
        slideTransition(e);
      });
      navArrow.addEventListener('keyup', (e) => {
        if (!(e.key === 'Enter')) return;
        slideTransition(e);
      });
    });
  });
})();
